import { IconControl } from "spark-core-dx/components";
import { useFullscreen } from "../../../../contexts/FullScreenContext";

export const CardViewModeOptions = ({ visual, onFullScreen, onExport, removeContextMenu }) => {
    const { isFullscreen } = useFullscreen();

    return (
        <CardTileContextOptions>
            <CardContextOption
                icon={!isFullscreen ? 'fullscreen' : 'close'}
                text={!isFullscreen ? 'Full Screen' : 'Close'}
                onClick={() => {
                    removeContextMenu();
                    onFullScreen();
                }}
            />
            <CardContextOption
                icon={'fileexport'}
                text={'Export'}
                onClick={() => { removeContextMenu(); onExport(visual) }}
            />
        </CardTileContextOptions>
    )
}


export const CardDesignModeOptions = ({ visual, onEdit, onClone, onHide, onDelete, onLock, onFullScreen, removeContextMenu }) => {
    const { isFullscreen } = useFullscreen();

    return (
        <CardTileContextOptions>
            <CardContextOption
                icon={!isFullscreen ? 'fullscreen' : 'close'}
                text={!isFullscreen ? 'Full Screen' : 'Close'}
                onClick={() => { removeContextMenu(); onFullScreen?.(); }}
            />
            <CardContextOption
                icon={'edit'}
                text={'Edit'}
                onClick={() => { removeContextMenu(); onEdit(visual) }}
            />
            <CardContextOption
                icon={'clone'}
                text={'Clone'}
                onClick={() => { removeContextMenu(); onClone(visual) }}
            />
            <CardContextOption
                icon={'remove'}
                text={'Hide'}
                onClick={() => { removeContextMenu(); onHide(visual) }}
            />
            <CardContextOption
                icon={'delete'}
                text={'Delete'}
                onClick={() => { removeContextMenu(); onDelete(visual) }}
            />
            <CardContextOption
                icon={visual.IsLocked ? 'lockopen' : 'lock'}
                text={visual.IsLocked ? 'Unlock Chart' : 'Lock Chart'}
                onClick={() => { removeContextMenu(); onLock(visual) }}
            />
        </CardTileContextOptions>
    );
}

export const CardTileContextOptions = ({ children }) => (
    <div className={'options-wrapper'}>{children}</div>
)

export const CardContextOption = ({ icon, text, onClick, disabled = false }) => (
    <div
        className={`option ${disabled ? 'disabled' : ''}`}
        onClick={(e) => handleContextOptionClick(e, onClick)}
        onMouseDown={e => e.stopPropagation()}
    >
        <IconControl iconKey={icon} />
        {text}
    </div>
)

const handleContextOptionClick = (event, callback) => {
    event?.stopPropagation();
    callback();
}
